import FrequentlyUsedField from "@/enum/FrequentlyUsedField";
import FrequentlyUsedFieldNameMap from "@/map/FrequentlyUsedFieldNameMap";
import { Checkbox } from "antd";
import React, { useRef, useState } from "react";

interface SearchFieldDragItemProps {
    frequentlyUsedField: FrequentlyUsedField;

    index: number;

    draggable: boolean;

    onChange(action: SearchFieldDragAction, originIndex: number, targetIndex: number);
}

export enum SearchFieldDragAction {
    REPLACE = "REPLACE",

    INSERT_AFTER = "INSERT_AFTER",
}

const SearchFieldDragItem: React.FC<SearchFieldDragItemProps> = (props) => {
    const [dragCol, setDragCol] = useState(false);

    const [hoverSpan, setHoverSpan] = useState(false);

    const [hoverCol, setHoverCol] = useState(false);

    const { frequentlyUsedField, index, onChange, draggable } = props;

    const spanRef = useRef<HTMLSpanElement>();

    const colRef = useRef<HTMLDivElement>();

    function handleDragStart(e: React.DragEvent<HTMLDivElement>) {
        e.stopPropagation();

        setDragCol(true);

        e.dataTransfer.effectAllowed = "move";

        const element = spanRef.current;

        const rect = element.getBoundingClientRect();

        e.dataTransfer.setDragImage(element, e.clientX - rect.left, e.clientY - rect.top);

        e.dataTransfer.setData("originIndex", String(index));
    }

    function handleDragEnd(e: React.DragEvent<HTMLDivElement>) {
        e.stopPropagation();

        setDragCol(false);
    }

    function handleDragOver(e: React.DragEvent<HTMLDivElement>) {
        e.stopPropagation();

        e.preventDefault();

        e.dataTransfer.dropEffect = "move";

        const { clientX } = e;

        const { left, width } = colRef.current.getBoundingClientRect();

        /** 重置 */
        setHoverCol(false);
        setHoverSpan(false);

        if (!dragCol) {
            if (clientX - left > width * 0.6) {
                setHoverCol(true);
            } else {
                setHoverSpan(true);
            }
        }
    }

    function handleDragLeave() {
        if (!dragCol) {
            setHoverSpan(false);
            setHoverCol(false);
        }
    }

    function handleDrop(e: React.DragEvent<HTMLDivElement>) {
        if (!dragCol) {
            const originIndexStr = e.dataTransfer.getData("originIndex");

            const originIndex = Number(originIndexStr);

            if (originIndex === index) return;

            /** 替换 */
            if (hoverSpan) {
                onChange(SearchFieldDragAction.REPLACE, originIndex, index);
            } else if (hoverCol) {
                onChange(SearchFieldDragAction.INSERT_AFTER, originIndex, index);
            }
        }

        setHoverSpan(false);
        setHoverCol(false);
    }

    let spanStyle: React.CSSProperties = { padding: "2px" };

    if (dragCol) {
        spanStyle = { boxSizing: "border-box", background: "#d9d9d9", padding: "2px" };
    } else if (hoverSpan) {
        spanStyle = { boxSizing: "border-box", background: "#69c0ff", padding: "2px" };
    }

    let colStyle: React.CSSProperties = { padding: "2px" };

    if (hoverCol) {
        colStyle = { borderRight: "solid 2px #69c0ff", boxSizing: "border-box", padding: "2px" };
    }

    return (
        <div
            style={colStyle}
            className="order-search-pane-setting-item"
            draggable={draggable}
            onDragStart={draggable ? handleDragStart : undefined}
            onDragEnd={draggable ? handleDragEnd : undefined}
            onDragOver={draggable ? handleDragOver : undefined}
            onDragLeave={draggable ? handleDragLeave : undefined}
            onDrop={draggable ? handleDrop : undefined}
            ref={colRef}
        >
            <Checkbox key={frequentlyUsedField} value={frequentlyUsedField} style={spanStyle}>
                <span className="order-search-pane-setting-item-label" ref={spanRef}>
                    {FrequentlyUsedFieldNameMap[frequentlyUsedField]}
                </span>
            </Checkbox>
        </div>
    );
};

export default React.memo(SearchFieldDragItem);
